import Vue from 'vue'
import langList from '~/static/json/languageList.json'
import areaCodeCN from '~/static/json/areaCodeCN.json'
const offsetGMT = new Date().getTimezoneOffset() * 60 * 1000
const now = new Date().getTime() - offsetGMT
// lodash一些实用方法：
// _.add(number1, number2) // 两数相加
// _.subtract(number1, number2) // 两数相减
// _.multiply(number1, number2) // 两数相乘
// _.divide(number1, number2) // 两数相除
// _.ceil(number, 2) // 根据精度值向上舍入number
// _.floor(number, 2) // 根据精度值向下舍入number
// _.round(number, 2) // 根据精度值四舍五入number
// _.max(array) // 计算简单数组中的最大值
// _.min(array) // 计算简单数组中的最小值
// _.sum(array) // 计算简单数组值的总和
// _.sumBy([{ n: 1 }, { n: 2 }], 'n') // 根据第二个参数值作为条件返回总和
// _.maxBy([{ n: 1 }, { n: 2 }], 'n') // 根据第二个参数值作为条件返回最大的值
// _.minBy([{ n: 1 }, { n: 2 }], 'n') // 根据第二个参数值作为条件返回最小的值
// _.cloneDeep([{ n: 1 }, { n: 2 }]) // 深拷贝
// _.split('a-b-c', '-', 2) // 根据分隔符拆分字符串，并限制返回数组的长度

// 公用方法
export const currProject = {
  setRating (v) {
    if (v > 8.54) {
      return 'AAA'
    } else if (v >= 8) {
      return 'AA'
    } else if (v >= 7) {
      return 'A'
    } else if (v >= 6) {
      return 'B'
    } else if (v >= 4.56) {
      return 'C'
    } else if (v <= 4.55 && v > 0) {
      return 'D'
    } else {
      return 'E'
    }
  },
  // 相同交易商名字
  getshortName (sName, sName1) {
    // shortName 放前面 localShortName放后面
    if (sName == sName1) {
      return sName
    } else {
      return `${sName || ''} ${sName1 || ''}`
    }
  },
  // 只取交易商简称
  getOnlyShortName (sName, sName1) {
    if (!sName) {
      return sName1
    } else {
      return sName
    }
  },
  // 数字千分位展示
  num2CurrencyNo (value = 0) {
    if (!value) return 0
    const intPart = Math.trunc(value) // 获取整数部分
    const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 整数部分处理，增加,
    let floatPart = '' // 预定义小数部分
    const valueArray = value.toString().split('.') // 将数值截取为小数部分和整数部分
    if (valueArray.length == 2) { // 有小数部分
      floatPart = valueArray[1].toString() // 取得小数部分
      return intPartFormat + '.' + floatPart
    }
    return intPartFormat + floatPart
  },
  // 当前选择的语言code
  currLangCode () {
    return this.$store.state.LanguageCode || 'en'
  },
  // 当前选择的国家code
  currCountry (key = '') {
    let obj = this.$store.state?.getCountry
    const myCountry = this.$store.state?.myCountry
    const CountryCode = this.$store.state?.CountryCode
    if (obj.countryCode == '156') {
      obj = {
        code: '156',
        twoCharCode: 'CN',
        name: myCountry == 'cn' || myCountry == 'hk' || CountryCode == 'cn' || CountryCode == 'hk' ? '中国香港' : '香港',
        flag: 'https://img.wikifx.com/flag/ccc558d92f93bcf8/HK.png_wiki-template-global', // 'https://img.wikifx.com/flag/7d8833382673bab2/CN.png_wiki-template-global'
        'flag-c': 'https://img.wikifx.com/flag/ccc558d92f93bcf8/HK.png_wiki-template-global' // 'https://img.wikifx.com/flag-c/7d8833382673bab2.png_wiki-template-global'
      }
    } else if (obj.countryCode == '158') {
      obj = {
        twoCharCode: 'TW',
        code: '158',
        name: myCountry == 'cn' || myCountry == 'hk' || CountryCode == 'cn' || CountryCode == 'hk' ? '中国台湾' : '台湾',
        flag: 'https://img.wikifx.com/flag/6be3087ca199f440/TW.png_wiki-template-global',
        'flag-c': 'https://img.wikifx.com/flag-c/6be3087ca199f440.png_wiki-template-global'
      }
    } else {
      obj = {
        code: obj.countryCode,
        twoCharCode: obj.twoCharCode,
        name: (obj.countryCode == '344') ? obj.name.replace('中国', '').replace('中國', '').replace('China', '') : obj.name,
        flag: obj.flag, // 'https://img.wikifx.com/flag/7d8833382673bab2/CN.png_wiki-template-global'
        'flag-c': obj.flag // 'https://img.wikifx.com/flag-c/7d8833382673bab2.png_wiki-template-global'
      }
    }
    if (!key) return obj
    return obj[key] || ''
  },
  // 真实的国家code
  realuserCountry (key = '') {
    let obj = this.$store.state?.getCountry
    const myCountry = this.$store.state?.myCountry
    const CountryCode = this.$store.state?.CountryCode
    if (obj.countryCode == '156') {
      obj = {
        code: '156',
        twoCharCode: 'CN',
        name: myCountry == 'cn' || myCountry == 'hk' || CountryCode == 'cn' || CountryCode == 'hk' ? '中国香港' : '香港',
        flag: 'https://img.wikifx.com/flag/ccc558d92f93bcf8/HK.png_wiki-template-global', // 'https://img.wikifx.com/flag/7d8833382673bab2/CN.png_wiki-template-global'
        'flag-c': 'https://img.wikifx.com/flag/ccc558d92f93bcf8/HK.png_wiki-template-global' // 'https://img.wikifx.com/flag-c/7d8833382673bab2.png_wiki-template-global'
      }
    } else if (obj.countryCode == '158') {
      obj = {
        twoCharCode: 'TW',
        code: '158',
        name: myCountry == 'cn' || myCountry == 'hk' || CountryCode == 'cn' || CountryCode == 'hk' ? '中国台湾' : '台湾',
        flag: 'https://img.wikifx.com/flag/6be3087ca199f440/TW.png_wiki-template-global',
        'flag-c': 'https://img.wikifx.com/flag-c/6be3087ca199f440.png_wiki-template-global'
      }
    } else {
      obj = {
        code: obj.countryCode,
        twoCharCode: obj.twoCharCode,
        name: (obj.countryCode == '344') ? obj.name.replace('中国', '').replace('中國', '').replace('China', '') : obj.name,
        flag: obj.flag, // 'https://img.wikifx.com/flag/7d8833382673bab2/CN.png_wiki-template-global'
        'flag-c': obj.flag // 'https://img.wikifx.com/flag-c/7d8833382673bab2.png_wiki-template-global'
      }
    }
    if (!key) return obj
    return obj[key] || ''
  },
  // 用户所在的国家简称（如CN）
  userCountry () {
    return this.$store.state.myCountry
  },
  // 获取用户选择的语言信息
  getMyLang (obj = {}) {
    const key = Object.keys(obj)[0]
    const result = langList?.find(item => item[key] == obj[key])
    return result || {}
  },
  // 获取用户所在的国家信息
  getMyCountry (obj = {}) {
    const key = Object.keys(obj)[0]
    for (let i = 0; i < areaCodeCN.length; i++) {
      const result = areaCodeCN[i]?.data?.find(each => each[key] == obj[key])
      if (!result) continue
      return result
    }
    return {} // 未找到结果，返回空对象
  },
  // 涨跌（绿涨红跌/红涨绿跌）
  riseFn (value = 0) {
    const isChina = ['156', '158', '344'].includes(String(this.$store.state?.getCountry?.countryCode))
    return isChina ? (value > 0 ? -1 : (value < 0 ? 1 : 0)) : (value > 0 ? 1 : (value < 0 ? -1 : 0))
  },
  // 字符串过滤表情包
  filterEmoji (str = '', isbool = false) {
    // 只匹配img、br、hr、input标签
    const reg2 = new RegExp('<(img|br|hr|input)[^>]*>', 'gi') // eslint-disable-line
    // 分组匹配，过滤全部的html标签，包括内容
    const reg3 = new RegExp('<(\\S*)[^>]*>[^<]*<\\/(\\1)>', 'gi') // eslint-disable-line
    return filterHtmlOrContainer(str, isbool)
    // str需要过滤的字符串，isbool为false则需要单标签过滤、为true则不需要单标签过滤
    function filterHtmlOrContainer (str, isbool) {
      if (typeof str != 'string') return str // 不是字符串
      let result = str
      if (!isbool) result = result.replace(reg2, '') // 先过滤单标签
      result = result.replace(reg3, '') // 先通过分组匹配，把双标签去除，若是是嵌套标签，则会先将嵌套标签内的双标签过滤掉
      if (reg3.test(result)) return filterHtmlOrContainer(result, true) // 若为true，则表明还有标签
      else return result
    }
  },
  momentTime (timestamp, type = 0) { // timestamp传时间戳--格式化时间type为0默认，实堪=1；快讯为2；财经日历为3
    // console.log(offsetGMT, 9199, new Date().getTimezoneOffset(), new Date(now))
    if (!timestamp) return
    if (String(timestamp).includes('T')) {
      timestamp = Date.parse(timestamp)
    }
    if (`${timestamp}`.length < 12) timestamp = timestamp * 1000
    const timer = new Date(timestamp - offsetGMT)
    const yyyy = timer.getUTCFullYear() // 年
    const mm = (timer.getUTCMonth() + 1) > 9 ? (timer.getUTCMonth() + 1) : ('0' + (timer.getUTCMonth() + 1)) // 月
    const dd = timer.getUTCDate() > 9 ? timer.getUTCDate() : ('0' + timer.getUTCDate()) // 日
    const hh = timer.getUTCHours() > 9 ? timer.getUTCHours() : ('0' + timer.getUTCHours()) // 时
    const min = timer.getUTCMinutes() > 9 ? timer.getUTCMinutes() : ('0' + timer.getUTCMinutes()) // 分
    const ss = timer.getUTCSeconds() > 9 ? timer.getUTCSeconds() : ('0' + timer.getUTCSeconds()) // 秒
    let time = ''
    if (type == 0) {
      const lang = this.$store.state.LanguageCode
      if (lang == 'zh-cn' || lang == 'zh-tw' || lang == 'zh-hk') {
        const momen = now - timer
        // console.log(momen, 666)
        switch (true) {
          case momen >= 0 && momen < 600000:
            time = this.$v('刚刚')
            break
          case momen >= 600000 && momen < 3600000:
            time = this.$v('{0}分钟前').replace('{0}', Math.round(momen / 60000))
            break
          case momen >= 3600000 && momen < 86400000:
            time = this.$v('{0}小时前').replace('{0}', Math.round(momen / 3600000))
            break
          case momen >= 86400000 && momen < 259200000:
            time = this.$v('{0}天前').replace('{0}', Math.round(momen / 86400000))
            break
          case momen >= 259200000 && momen < 604800000:
            time = this.$v('{0}周内').replace('{0}', 1)
            break
          default:
            time = `${yyyy}-${mm}-${dd} ${hh}:${min}`
            break
        }
      } else {
        time = `${yyyy}-${mm}-${dd} ${hh}:${min}`
      }
    } else if (type == 1) {
      time = `${yyyy}-${mm}-${dd}`
    } else if (type == 2) {
      time = `${hh}:${min}:${ss}`
    } else if (type == 3) {
      time = `${hh}:${min}`
    }
    return time
  },
  setStarIcon (score) {
    try {
      let html = ''
      if (score != null && !isNaN(score)) {
        score = Number(score) + 1
        if (score > 10) {
          score = 10
        }
        const newScore = parseInt(score / 2)
        if (newScore > 0) {
          for (let i = 0; i < newScore; i++) {
            html += "<i class='iconfont icon-a-1'></i>"
          }
        }
        let empty = 0
        if (score % 2 >= 1) {
          empty = 1
          html += "<i class='iconfont icon-star-empty'></i>"
        }
        const hfi = (5 - (newScore + empty))
        for (let s = 0; s < hfi; s++) {
          html += "<i class='iconfont icon-star-empty-1'></i>"
        }
      }
      return html
    } catch {
      return ''
    }
  },
  setStarIcon2 (score) { // 详情页
    try {
      let html = ''
      if (score != null && !isNaN(score)) {
        score = Number(score) + 1
        if (score > 10) {
          score = 10
        }
        const newScore = parseInt(score / 2)
        if (newScore > 0) {
          for (let i = 0; i < newScore; i++) {
            html += "<i class='iconfont icon-a-1'></i>"
          }
        }
        let empty = 0
        if (score % 2 >= 1) {
          empty = 1
          html += "<i class='iconfont icon-star-empty'></i>"
        }
        const hfi = (5 - (newScore + empty))
        for (let s = 0; s < hfi; s++) {
          html += "<i style='color:rgba(0, 0, 0, 0.2);' class='iconfont icon-star-filled1'></i>"
        }
      }
      return html
    } catch {
      return ''
    }
  },
  alternate () { // 设置页面的meta这块的alternate
    let lang = []
    const name = this.$route.name
    if (name == 'lang-wikilist.html') {
      const alllang = [{
        lang: 'en',
        hreflang: 'en'
      }, {
        lang: 'zh-cn',
        hreflang: 'zh-Hans'
      }, {
        lang: 'zh',
        hreflang: 'zh-Hant'
      }]
      lang = [...alllang]
    } else if (name == 'lang-learnlist.html' || name == 'lang-learnlist-pre-school.html' ||
     name == 'lang-learnlist-elementary.html' || name == 'lang-learnlist-middleschool.html' || name == 'lang-learnlist-summer-camp.html' ||
      name == 'lang-learnlist-highschool.html' || name == 'lang-learnlist-undergraduate.html' || name == 'lang-learnlist-graduation.html') {
      const alllang = [{
        lang: 'en',
        hreflang: 'en'
      }, {
        lang: 'zh-cn',
        hreflang: 'zh-Hans'
      }, {
        lang: 'zh',
        hreflang: 'zh-Hant'
      }, {
        lang: 'vi',
        hreflang: 'vi'
      }, {
        lang: 'ru',
        hreflang: 'ru'
      }, {
        lang: 'es',
        hreflang: 'es'
      }, {
        lang: 'th',
        hreflang: 'th'
      }, {
        lang: 'fil',
        hreflang: 'tl'
      }]
      lang = [...alllang]
    } else {
      const alllang = [{
        lang: 'en',
        hreflang: 'en'
      }, {
        lang: 'zh-cn',
        hreflang: 'zh-Hans'
      }, {
        lang: 'zh',
        hreflang: 'zh-Hant'
      }, {
        lang: 'ja',
        hreflang: 'ja'
      }, {
        lang: 'id',
        hreflang: 'id'
      }, {
        lang: 'vi',
        hreflang: 'vi'
      }, {
        lang: 'ru',
        hreflang: 'ru'
      }, {
        lang: 'es',
        hreflang: 'es'
      }, {
        lang: 'th',
        hreflang: 'th'
      }, {
        lang: 'fil',
        hreflang: 'tl'
      }, {
        lang: 'it',
        hreflang: 'it'
      }, {
        lang: 'fr',
        hreflang: 'fr'
      }, {
        lang: 'pt',
        hreflang: 'pt'
      }, {
        lang: 'ko',
        hreflang: 'ko'
      }, {
        lang: 'de',
        hreflang: 'de'
      }, {
        lang: 'hi',
        hreflang: 'hi'
      }, {
        lang: 'tr',
        hreflang: 'tr'
      }, {
        lang: 'ar',
        hreflang: 'ar'
      }]
      lang = [...alllang]
    }
    const arrLink = []
    const href = (this.$store.state.allHost.includes('?') && !this.$store.state.allHost.includes('revelation') && !this.$store.state.allHost.includes('exposure/slist')) ? (this.$store.state.allHost.substring(0, this.$store.state.allHost.indexOf('?'))) : this.$store.state.allHost
    let hrefT = ''
    lang.forEach((item) => {
      hrefT = href.replace(this.$store.state.LanguageCode, item.lang)
      arrLink.push({ rel: 'alternate', hreflang: item.hreflang, href: hrefT })
    })
    arrLink.push({ rel: 'alternate', hreflang: 'x-default', href: href.replace(this.$store.state.LanguageCode, 'en') })
    return arrLink
  },
  canonical () { // 设置页面的meta这块的canonical
    const arrLink = []
    let href = (this.$store.state.allHost.includes('?') && !this.$store.state.allHost.includes('revelation') && !this.$store.state.allHost.includes('exposure/slist')) ? (this.$store.state.allHost.substring(0, this.$store.state.allHost.indexOf('?'))) : this.$store.state.allHost
    if (href.includes('wikifx2') || href.includes('test')) {
      href = href.replace('wikifx2', 'wikifx').replace('test', 'www')
    }
    arrLink.push({ rel: 'canonical', href })
    return arrLink
  },
  // 根据id获取用户信息
  async getUserInfo () {
    if (!this.$store.state.user.userId) return null
    const LanguageCode = this.$store.state.LanguageCode
    const CountryCode = this.$store.state.CountryCode
    const { succeed = false, extra = '', result = {} } = await this.$api.home.getUserinfo(({ UserId: this.$store.state.user.userId, ApplicationType: 7, CountryCode, LanguageCode, Ppl: 7, Poy: 1 })) // 2.使用id获取用户信息
    if (!succeed) return this.$message.error(extra) // 数据错误
    // console.log('result', result)
    this.$store.commit('setUserInfo', result)
  },
  langType () { // 语言类别判断就是长短语言--短语言为true，长语言为false
    let bool = false
    if (this.$store.state.LanguageCode == 'zh-cn' || this.$store.state.LanguageCode == 'zh-tw' || this.$store.state.LanguageCode == 'zh-hk') bool = true
    else bool = false
    return bool
  },
  homelangType () { // 首页判断字体是否为斜体长短语言--短语言为true，长语言为false
    let bool = false
    if (this.$store.state.LanguageCode == 'zh-cn' || this.$store.state.LanguageCode == 'zh-tw' || this.$store.state.LanguageCode == 'zh-hk' || this.$store.state.LanguageCode == 'vi' || this.$store.state.LanguageCode == 'th') bool = true
    else bool = false
    return bool
  },
  async gettraderName (codes) { // 历史记录返回
    const data = await this.$api.dealer.gettraderbycodes({
      codes: codes.join()
    }).then((res) => {
      const traderArr = []
      codes.forEach((item) => {
        const arr = res && res.filter(t => t.code == item)
        traderArr.push(...arr)
      })
      return traderArr
      // this.fxeyedirectArr = [...traderArr]
    })
    return data
  },
  vpslogo () { // 根据语种判断vps-logo
    const lang = ['zh-cn', 'zh']
    if (lang.includes(this.$store.state.LanguageCode)) {
      return `https://resources.interface003.com/web20/img/home/traderBg.png?v=${new Date()}`
    } else {
      return `https://resources.interface003.com/web20/img/rankingList/iocn-bg.png?v=${new Date()}`
    }
  },
  matomofn(event, obj) {
    console.log('埋点matomofn', event, obj)
    // matomo埋点
    const bfp = this.$cookies.get('wiki-bfp') ? this.$cookies.get('wiki-bfp') : '822ca7b3261a0b2ec10c8cdabfb5a0ea'
    let base = `999,0,2,999,0,${bfp},0`
    if (this.$store.state.isWiki == '1') {
      base = `999,0,2,999,0,${bfp},0`
    } else if (this.$store.state.myCountry == 'cn') {
      base = `999,0,1,999,1,${bfp},1`
    } else {
      base = `999,0,2,999,0,${bfp},0`
    }
    let str = ''
    for (const key in obj) {
      str += `&${key}=${obj[key]}`
    }
    window?._paq?.push([
      'trackEvent',
      `userid=${this.$store.state.user.userId}&basicdata=${base}&Langugecode=${this.$store.state.LanguageCode}&countryCode=${this.$store.state.CountryCode}${str}`,
      'Click',
      event
    ])
  }
}

Object.keys(currProject).forEach((item) => {
  Vue.prototype[item] = currProject[item]
})
